export const environment = {
  production: true,
  urlLoginMaverick: 'https://portal.solidabrasil.com.br:4200/login',
  urlGestaoArquivo: 'https://gestao-arquivo.solidabrasil.com.br',
  urlApiProtheus: 'https://servicos.solidabrasil.com.br:9099/rest',
  dominioAD: 'SOLIDABRASIL\\',
  patternPadraoTotvs: "^[A-Za-z0-9\\\\/()\\\{\\\}\\\[\\\]\\\*\\\.\\\,;?!@#$%&-_=+ ]+$",
};
